// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"672fa17f","453":"27e843d3"}[chunkId] + ".chunk.js";
};